function loadShadowDom(sku, store) {
    var shadowDomContainer = document.createElement("div");

    var template = document.getElementById('reviews-widget-template');
    shadowDomContainer.appendChild(template.content);

    var link = document.createElement("link");
    link.href = 'https://widget.reviews.co.uk/combined/style.css?v1';
    link.type = "text/css";
    link.rel = "stylesheet";
    shadowDomContainer.appendChild(link);

    // create container to hold the reviews
    var reviewsContainer = document.createElement("div");
    reviewsContainer.id = 'shadow-dom-reviews-div';
    shadowDomContainer.appendChild(reviewsContainer);

    const shadowEl = document.getElementById('reviews-widget');
    var shadowRoot = shadowEl.attachShadow({mode: 'open'});
    shadowRoot.appendChild(shadowDomContainer);

    var options = {
        store: store,
        widget: 'combined-widget',
        querySelector: shadowEl.shadowRoot.querySelector('#shadow-dom-reviews-div'),
        options: {
            types: 'product_review',
            per_page: 10,
            product_review: {
                sku: sku,
                enable_write_review: false,
                enable_smart_filters: true,
                enable_rating_filters: true,
                enable_toggle_filters: false,
                enable_social_sharing: false,
                enable_helpful: true,
                enable_featured_review_photos: false,
                enable_featured_social_photos: false,
                show_mention_text: true,
                show_dates: true,
                show_replies: false,
                show_avatars: true,
                show_photos: false,
                show_verify_status: true
            },
        },
        avatars: {
            enable_gravatar: false,
            gravatar_fallback: 'identicon'
        },
        reviewsLogo: {
            show_logo: false,
            style: 'black'
        }
    };
    new ReviewsWidget('#anything', options);
}
// data-show-most-helpful
var shadowDomLoaded = false;
$('a[data-show-all-reviews]').on('click', function() {
    $(this).addClass('btn-active');
    $('a[data-show-most-helpful]').removeClass('btn-active');
    $('[data-top-reviews]').hide();
    $('[data-reviews-widget]').fadeIn();

    if (!shadowDomLoaded) {
        loadShadowDom(REVIEW_SKU, REVIEW_STORE_ID);
        shadowDomLoaded = true;
    }
});

$('a[data-show-most-helpful]').on('click', function() {
    $(this).addClass('btn-active');
    $('a[data-show-all-reviews]').removeClass('btn-active');
    $('[data-reviews-widget]').hide();
    $('[data-top-reviews]').fadeIn();
});
